<template>
    <div class="flex flex-col tracking-wider w-full max-w-[530px] p-8 border border-gray-100 lg:border-gray-300 rounded-md bg-gray-100 text-gray-700">
        <div class="text-xl pb-6 border-b border-gray-300 w-full flex justify-start text-center items-center space-x-2">
            <tracked-link :link="{ path: '/profile/', label: 'User Profile', displayLabel: false, class: 'inline'}">
                <div class="p-1.5 hover:bg-gray-200 rounded cursor-pointer">
                    <ChevronLeftSVG />
                </div>
            </tracked-link>
            <div>Change Password</div>
        </div>
        <ForgotPasswordForm class="pt-6" :email="email" />
    </div>
</template>

<script setup>
import { defineProps, ref, reactive, computed, onMounted } from 'vue';
import { sendPasswordResetLink } from '@/services/Auth';
import ChevronLeftSVG from '../svg-components/ChevronLeftSVG.vue';
import TrackedLink from '../nav-bar-link-components/TrackedLink.vue';
import LoadingSpinner from '../base-components/LoadingSpinner.vue';
import { handleRestAuthResponseError } from '@/composables/djRestAuth';
import ForgotPasswordForm from './ForgotPasswordForm.vue';

import { useRouter } from 'vue-router';

const router = useRouter()

const props = defineProps(['email'])
</script>